<template>
  <div class="rule-box">
    <registerRule></registerRule>
  </div>
</template>

<script>
  import vHead from "../components/Subhead.vue";
  import { Collapse, CollapseItem } from "vant";
  import registerRule from "wordsPath/registerRule.vue";
  export default {
    data() {
      return {
        activeNames: '1',
        title: "入会须知"
      };
    },
    components: {
      vHead,
      [Collapse.name]: Collapse,
      [CollapseItem.name]: CollapseItem,
      registerRule
    }
  };
</script>

<style lang="less" scoped>
  .content {
    font-size: 14px;
    line-height: 2;
    color: #333;
  }

  p {
    margin-bottom: 10px;

    color: #333;
  }

  b {
    font-weight: bold;
    margin-right: 10px;
  }

  ul {
    li {
      margin: 5px 0;
      font-size: 13px;
      color: #666;
    }
  }

  /deep/.van-cell {
    padding: 15px 20px;
  }
</style>